Postlogin.Lesson = (function (my) {
    my.HTMLContentSegment = function (segmentData) {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);

        me.html_content = segmentData.html;

        me.play_pause_enabled = false;
        me.replay_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container;

        me.init = function () {
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();

            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            const safeHtml = DOMPurify.sanitize(me.html_content);
            segmentContainer.append(`<div class="html-content-container">${safeHtml}</div>`);

            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        me.show = function () {
            me.setup();
            me.setupNextButton();
        };

        me.hide = function () {
            me.breakdown();
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
